import React from 'react';
import get from 'lodash/get';
import last from 'lodash/last';
import first from 'lodash/first';
import classnames from 'classnames';
import isEqual from 'lodash/isEqual';
import partial from 'lodash/partial';
import moment from 'moment-timezone';
import {FormattedMessage} from 'react-intl';
import {DateTimePicker} from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import {Button, Grid, Icon, Label} from 'semantic-ui-react';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';

export default class PrizeDrawInfo extends React.Component {
  static defaultProps = {
    // statuses of auto-saved drawDate edits
    saveStatuses: [],

    // auto-save status of newly-created drawDate
    newDrawDateStatus: {}
  };

  state = {
    errors: []
  };

  validate = (index, value) => {
    const errors = [];

    // create a list current drawDates with the new value swapped in so we can compare it
    // with the others, in order.
    const drawDates = this.prizeDrawInfo.map(({drawDate}, i) => i === index ? value : drawDate);

    // drawDates must be in chronological order.
    const chronological = isEqual(drawDates, [...drawDates].sort((a, b) => a - b));

    if (!chronological) {
      errors.push('errors.validation.prize.drawInfo.chronological');
    }

    // drawDates must occur within the prize's {start,end}Time range.
    const firstIsInRange = first(drawDates) >= moment(this.props.prize.startTime).valueOf();
    const lastIsInRange = last(drawDates) <= moment(this.props.prize.endTime).valueOf();

    if (!(firstIsInRange && lastIsInRange)) {
      errors.push('errors.validation.prize.drawInfo.range');
    }

    return errors;
  };

  onChange = (index, value) => {
    const unixMillis = moment(value).valueOf();
    const errors = this.validate(index, unixMillis);

    if (errors.length !== this.state.errors.length) {
      this.setState({errors});
    } else {
      this.props.onValueChanged(index, unixMillis);
    }
  };

  // safe getter for the case of a Prize without a `drawInfo` property.
  get prizeDrawInfo() {
    return get(this.props.prize, 'drawInfo', []);
  }

  get hasErrors() {
    return this.state.errors.length > 0;
  }

  get isAddingItem() {
    return this.props.newDrawDateStatus.isSaving;
  }

  componentWillMount() {
    moment.locale('en');
    momentLocalizer();
  }

  componentDidUpdate(prevProps, prevState) {
    // validate newly-added draw dates.
    let currentLength = this.prizeDrawInfo.length;
    let oldLength = get(prevProps.prize, 'drawInfo', []).length;

    if (currentLength === 0) {
      // nothing to validate
      return;
    }

    if (currentLength !== oldLength) {
      const newDrawInfoItem = last(this.prizeDrawInfo);
      const errors = this.validate(this.prizeDrawInfo.indexOf(newDrawInfoItem), newDrawInfoItem.drawDate);

      if (errors.length !== this.state.errors.length) {
        this.setState({errors});
      }
    }
  }

  render() {
    return (
      <div className={classnames('prize-draw-info', this.props.className, {error: this.hasErrors})}>
        {this.state.errors.map(error => (
          <Label basic className='db-error-label'>
            <FormattedMessage id={error} />
          </Label>
        ))}
        <ol>
          {this.prizeDrawInfo.map((drawInfoItem, index) => {
            const {isSaving, error, saved} = this.props.saveStatuses[index];

            return (
              <li key={drawInfoItem.id}>
                <Grid columns={2}>
                  <Grid.Row>
                    <label>
                      <FormattedMessage id={this.props.labelKey} values={{num: index + 1}} />
                    </label>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <DateTimePicker
                        onChange={partial(this.onChange, index)}
                        value={moment(drawInfoItem.drawDate).toDate()} />
                    </Grid.Column>
                    <Grid.Column width={1}>
                      <Grid columns={2}>
                        <Grid.Row>
                          <Grid.Column width={8}>
                            <Icon name='remove' onClick={partial(this.props.onRemoveItem, index)} />
                          </Grid.Column>
                          <Grid.Column width={8}>
                            <FieldStatusIcon error={error} saved={saved} isSaving={isSaving} />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </li>
            );
          })}
        </ol>
        <Button
          primary
          loading={this.isAddingItem}
          disabled={this.isAddingItem}
          onClick={this.props.onAddItem}>
          <Icon name='plus' />
          <FormattedMessage id='add' />
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./public/pages/EditPrize/PrizeDrawInfo.jsx